<template>
  <div class="navtab__box">
    <div ref="searchvillasel4" class="navtab-searchinput">
      <DesktopSearchVilla
        v-if="isDesktop"
        key="topNavSV"
        instanceName="nav"
        :text-arrival="textArrival"
        :text-departure="textDeparture"
        :text-destination-label="textDestinationLabel"
        :text-find-villas="textFindVillas"
        :region="region"
        section="nav"
        :showonly="showonly"
        destinations-top="-50px"
        tracking-category="search_topnav"
      />
    </div>
  </div>
</template>

<script>
import responsive from '../../../mixins/responsive.js';
import DesktopSearchVilla from '../../../components/searchvilla/DesktopSearchVilla.vue';

export default {
  mixins: [responsive],
  components: {
    DesktopSearchVilla,
  },
  props: {
    textArrival: {
      type: String,
      required: true,
    },
    textDeparture: {
      type: String,
      required: true,
    },
    textDestinationLabel: {
      type: String,
      required: true,
    },
    region: {
      type: String,
    },
    textFindVillas: {
      type: String,
      required: true,
    },
    showonly: {
      type: String,
    },
  },
};
</script>
